module.exports = __webpack_public_path__ + "static/img/04_coors.1c37dd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04_coors.jpg
// module id = SjcA
// module chunks = 0